import React, { Fragment } from 'react';
import { Card, Icon, Header } from 'semantic-ui-react';

export const ErrorGSQueryResults = () => {
  return (
    <Fragment>
      <Card className="title" style={{ marginBottom: '0px' }}>
        <Card.Content>
          <Header className="ean" as="h2">
            <Header.Content style={{ width: '100%' }}>
              <img
                src="ean.png"
                style={{
                  maxHeight: '60px',
                  display: 'block',
                  margin: 'auto'
                }}
                alt="ean logo"
              />
            </Header.Content>
          </Header>
        </Card.Content>
      </Card>
      <Card className="card-jmb" style={{ marginTop: '0px' }}>
        <Card.Content className="header ean">
          <Card.Header textAlign="left">
            <Icon name="warning sign" />
            GS Query Results (Error)
          </Card.Header>
        </Card.Content>
        <Card.Content>
          <p>There was an error loading the customer query results. Please try refreshing the page or contact support if the issue persists.</p>
        </Card.Content>
      </Card>
    </Fragment>
  );
};
